<div class="w-full mx-auto h-screen p-5">
    <h1 class="text-2xl font-bold mb-4">
        {{ isEditMode ? 'Editar orden de trabajo' : (currentWorkOrder ? 'Duplicar orden de trabajo' : 'Crear nueva orden
        de trabajo') }}
        <span *ngIf="isEditMode && workOrderId" class="text-lg text-gray-600">#{{ workOrderId }}</span>
        <span *ngIf="!isEditMode && currentWorkOrder" class="text-lg text-gray-600">(Copia de #{{ currentWorkOrder.id
            }})</span>
    </h1>

    <form [formGroup]="workOrderForm" (ngSubmit)="onSubmit()">

        <!-- thirdPartyId -->
        <div class="mb-4">
            <label for="thirdPartyId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Tercero</label>
            <!--            <select id="thirdPartyId" formControlName="thirdPartyId" class="w-full px-3 py-2 border rounded-md">-->
            <!--                <option value="" disabled selected>Seleccione un tercero</option>-->
            <!--                <option *ngFor="let thirdParty of thirdParties" [value]="thirdParty.id">-->
            <!--                    Documento: {{thirdParty.documentId}} Nombres: {{ thirdParty.firstName }} {{ thirdParty.lastName }}-->
            <!--                </option>-->
            <!--            </select>-->
            <p-dropdown id="thirdPartyId" formControlName="thirdPartyId" [filter]="true" filterBy="label"
                [showClear]="true" [options]="thirdParties" placeholder="Seleccione un tercero"
                (onFilter)="onSearchThirdParties($event)" class="w-full custom-dropdown">
            </p-dropdown>
            <div *ngIf="workOrderForm.get('thirdPartyId')?.invalid && workOrderForm.get('thirdPartyId')?.touched"
                class="text-red-500 text-sm">
                El Tercero es obligatorio.
            </div>
        </div>


        <!-- payerId -->
        <div class="mb-4">
            <label for="payerId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Ordenante Pagador</label>
            <!--            <select id="payerId" formControlName="payerId" class="w-full px-3 py-2 border rounded-md">-->
            <!--                <option value="" disabled selected>Seleccione un ordenante</option>-->
            <!--                <option *ngFor="let item of applicationUsersData" [value]="item.id">-->
            <!--                    {{ item.firstName }} {{ item.lastName }}-->
            <!--                </option>-->
            <!--            </select>-->
            <p-dropdown id="payerId" formControlName="payerId" [filter]="true" filterBy="label" [showClear]="true"
                [options]="applicationUsersData" placeholder="Seleccione un ordenante" class="w-full custom-dropdown">
            </p-dropdown>
            <div *ngIf="workOrderForm.get('payerId')?.invalid && workOrderForm.get('payerId')?.touched"
                class="text-red-500 text-sm">
                El Ordenante Pagador es obligatorio.
            </div>
        </div>

        <!-- paymentDate -->
        <div class="mb-4">
            <label for="paymentDate" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Fecha</label>
            <input type="date" id="paymentDate" formControlName="paymentDate"
                class="w-full px-3 py-2 border rounded-md">
            <div *ngIf="workOrderForm.get('paymentDate')?.invalid && workOrderForm.get('paymentDate')?.touched"
                class="text-red-500 text-sm">
                Fecha es obligatorio.
            </div>
        </div>

        <div class="bg-gray-200 p-5 shadow-lg rounded-lg text-left text-lg font-semibold mt-6 mb-6">
            Total Ejecutado: {{ totalExecutedAmount | currency:'COP' }}
        </div>


        <!-- Work Order Items (projectBudgetId, details, projectedAmount, qty, executedAmount) -->
        <div class="mb-4">
            <h2 class="text-xl font-bold mb-4">Ítems</h2>
            <div formArrayName="workOrderItems">
                <ng-container *ngFor="let item of workOrderItems.controls; let i = index">
                    <div formGroupName="{{i}}"
                        class="relative mb-4 p-4 rounded-lg shadow-md bg-white border border-gray-200">
                        <!-- Delete Button -->
                        <button type="button" (click)="removeWorkOrderItem(i)"
                            class="absolute top-2 right-2 bg-red-500 text-white p-1 hover:bg-red-600">
                            X
                        </button>

                        <div class="flex flex-col gap-6 xl:flex-row">

                            <!-- Proyecto/Presupuesto -->
                            <div class="w-full xl:w-1/2">
                                <label for="projectId" class="block text-gray-700 font-bold mb-2"
                                    appRequiredLabel>Proyecto/Presupuesto</label>
                                <!--                            <select id="projectBudgetId" (change)="getCategoryByProject($event, i)"-->
                                <!--                                    class="w-full px-3 py-2 border rounded-md">-->
                                <!--                              <option value="" disabled selected>Seleccione un proyecto</option>-->
                                <!--                              <option *ngFor="let project of projects" [value]="project.id">-->
                                <!--                                {{ project.projectId }} - {{ project.name }}-->
                                <!--                              </option>-->
                                <!--                            </select>-->
                                <p-dropdown id="projectId" formControlName="projectId" [filter]="true" filterBy="label"
                                    [showClear]="true" [options]="projects" placeholder="Seleccione un proyecto"
                                    (onFilter)="onSearchProjects($event)" (onChange)="getCategoryByProject($event,i)"
                                    class="w-full custom-dropdown">
                                </p-dropdown>
                                <div *ngIf="item.get('projectId')?.invalid && item.get('projectId')?.touched"
                                    class="text-red-500 text-sm">
                                    El Proyecto es obligatorio.
                                </div>
                            </div>

                            <!-- Categoría/Subcategoría -->
                            <div class="w-full xl:w-1/2">
                                <label for="projectBudgetId" class="block text-gray-700 font-bold mb-2"
                                    appRequiredLabel>Categoría/Subcategoría</label>
                                <!--                            <select id="projectBudgetId" (change)="loadProjectedAmount($event, i)"-->
                                <!--                                    formControlName="projectBudgetId" class="w-full px-3 py-2 border rounded-md">-->
                                <!--                              <option value="" disabled selected>Seleccione una categoría/subcategoría</option>-->
                                <!--                              <option *ngFor="let item of projectCategories[i]" [value]="item.id">-->
                                <!--                                {{ item.budgetSubcategory?.budgetCategory.name }} / {{ item.budgetSubcategory?.name }}-->
                                <!--                              </option>-->
                                <!--                            </select>-->
                                <p-dropdown id="projectBudgetId" formControlName="projectBudgetId" [filter]="true"
                                    filterBy="label" [showClear]="true" [options]="projectCategories[i]"
                                    placeholder="Seleccione una categoría/subcategoría"
                                    (onChange)="loadProjectedAmount($event, i)" class="w-full custom-dropdown">
                                </p-dropdown>
                            </div>

                            <!-- Proyecto/Presupuesto -->
                            <!--                            <div class="w-full xl:w-1/2">-->
                            <!--                                <label for="projectBudgetId" class="block text-gray-700 font-bold mb-2"-->
                            <!--                                    appRequiredLabel>Proyecto/Presupuesto</label>-->
                            <!--                                <select id="projectBudgetId" (change)="getCategoryByProject($event)"-->
                            <!--                                    class="w-full px-3 py-2 border rounded-md">-->
                            <!--                                    <option value="" disabled selected>Seleccione un proyecto</option>-->
                            <!--                                    <option *ngFor="let project of projects" [value]="project.id">-->
                            <!--                                        {{ project.projectId }} - {{ project.name }}-->
                            <!--                                    </option>-->
                            <!--                                </select>-->

                            <!--                            </div>-->

                            <!-- Categoría/Subcategoría -->
                            <!--                            <div class="w-full xl:w-1/2">-->
                            <!--                                <label for="projectBudgetId"-->
                            <!--                                    class="block text-gray-700 font-bold mb-2" appRequiredLabel>Categoría/Subcategoría</label>-->
                            <!--                                <select id="projectBudgetId" (change)="loadProjectedAmount($event, i)"-->
                            <!--                                    formControlName="projectBudgetId" class="w-full px-3 py-2 border rounded-md">-->
                            <!--                                    <option value="" disabled selected>Seleccione una categoría/subcategoría</option>-->
                            <!--                                    <option *ngFor="let item of categoriesSubcategories" [value]="item.id">-->
                            <!--                                        {{ item.budgetSubcategory?.budgetCategory.name }} / {{-->
                            <!--                                        item.budgetSubcategory?.name }}-->
                            <!--                                    </option>-->
                            <!--                                </select>-->
                            <!--                                <div *ngIf="item.get('projectBudgetId')?.invalid && item.get('projectBudgetId')?.touched"-->
                            <!--                                    class="text-red-500 text-sm">-->
                            <!--                                    Categoría/Subcategoría Obligatorio.-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                        </div>

                        <!-- Detalles -->
                        <div class="mb-4">
                            <label for="details" class="block text-gray-700 font-bold mb-2"
                                appRequiredLabel>Detalles</label>
                            <textarea id="details" formControlName="details"
                                class="w-full px-3 py-2 border rounded-md resize-none"></textarea>
                            <div *ngIf="item.get('details')?.invalid && item.get('details')?.touched"
                                class="text-red-500 text-sm">
                                Detalles es Obligatorio.
                            </div>
                        </div>

                        <!-- Monto Proyectado, Monto Ejecutado, Cantidad -->
                        <div class="mb-4 flex flex-col gap-6 xl:flex-row">
                            <div class="w-full xl:w-1/4">
                                <label for="projectedAmount" class="block text-gray-700 font-bold mb-2"
                                    appRequiredLabel>Monto
                                    Proyectado</label>
                                <input type="text" appCurrencyFormatter id="projectedAmount"
                                    formControlName="projectedAmount" readonly
                                    class="w-full px-3 py-2 border rounded-md">
                                <div *ngIf="item.get('projectedAmount')?.invalid && item.get('projectedAmount')?.touched"
                                    class="text-red-500 text-sm">
                                    Monto Proyectado Obligatorio.
                                </div>
                            </div>

                            <div class="w-full xl:w-1/4">
                                <label for="unitValue" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Valor
                                    Unitario</label>
                                <input type="text" appCurrencyFormatter id="unitValue" formControlName="unitValue"
                                    class="w-full px-3 py-2 border rounded-md">
                                <div *ngIf="item.get('unitValue')?.invalid && item.get('unitValue')?.touched"
                                    class="text-red-500 text-sm">
                                    Valor Unitario Obligatorio.
                                </div>
                                <span class="text-gray-500 text-sm">Antes de iva</span>
                            </div>

                            <div class="w-full xl:w-1/4">
                                <label for="qty" class="block text-gray-700 font-bold mb-2"
                                    appRequiredLabel>Cantidad</label>
                                <input type="number" id="qty" formControlName="qty"
                                    class="w-full px-3 py-2 border rounded-md">
                                <div *ngIf="item.get('qty')?.invalid && item.get('qty')?.touched"
                                    class="text-red-500 text-sm">
                                    Cantidad Obligatorio.
                                </div>
                            </div>

                            <div class="w-full xl:w-1/4">
                                <label for="vatAmount" class="block text-gray-700 font-bold mb-2"
                                    appRequiredLabel>IVA</label>
                                <input type="text" appCurrencyFormatter id="vatAmount" formControlName="vatAmount"
                                    (input)="calculateVAT(i, $event)" class="w-full px-3 py-2 border rounded-md">
                                <div *ngIf="item.get('vatAmount')?.invalid && item.get('vatAmount')?.touched"
                                    class="text-red-500 text-sm">
                                    Iva Obligatorio.
                                </div>
                            </div>

                            <div class="w-full xl:w-1/4">
                                <label for="executedAmount" class="block text-gray-700 font-bold mb-2"
                                    appRequiredLabel>Monto Ejecutado</label>
                                <input type="text" appCurrencyFormatter id="executedAmount"
                                    formControlName="executedAmount" class="w-full px-3 py-2 border rounded-md"
                                    readonly>
                                <div *ngIf="item.get('executedAmount')?.invalid && item.get('executedAmount')?.touched"
                                    class="text-red-500 text-sm">
                                    Monto Ejecutado Obligatorio.
                                </div>
                            </div>
                        </div>
                    </div>

                </ng-container>
            </div>

            <button (click)="addWorkOrderItem()" type="button"
                class="bg-gray-500 text-white px-4 py-2 rounded-md w-full">Agregar Ítem</button>
        </div>

        <div class="flex justify-end mt-4">
            <!-- Submit Button -->
            <button type="submit" [disabled]="!workOrderForm.valid" class="bg-blue-500 text-white px-4 py-2 rounded-md">
                {{ isEditMode ? 'Actualizar OT' : 'Crear OT' }} Por: {{totalExecutedAmount | currency: 'COP'}}
            </button>
        </div>

    </form>
</div>

<!-- Modal de Confirmación -->
<app-confirmation-modal #confirmationModal [isVisible]="showConfirmationModal" [config]="confirmationConfig"
    (confirmed)="onConfirmationModalConfirmed()" (cancelled)="onConfirmationModalCancelled()"
    (closed)="onConfirmationModalClosed()">
</app-confirmation-modal>